import React from 'react';

export const LayersButton: React.FC<{
  setEnabled: (enabled: boolean) => void;
  onClick?: () => void;
}> = ({ setEnabled, onClick }) => {
  return (
    <div
      className="gen-layers-button"
      onClick={() => {
        setEnabled(true);
        onClick?.();
      }}
    >
      Layers
    </div>
  );
};
